import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <main className="w-full min-h-screen overflow-x-hidden" style={{
    backgroundColor: 'var(--color-navy)'
  }} data-id="element-383">
      <HeroSection data-id="element-384" />
      <ProblemSection data-id="element-385" />
      <MechanismSection data-id="element-386" />
      <DeliverablesSection data-id="element-387" />
      <HowItWorksSection data-id="element-388" />
      <AudienceSection data-id="element-389" />
      <ProofSection data-id="element-390" />
      <FAQSection data-id="element-391" />
      <OfferSection data-id="element-392" />
      <FooterSection data-id="element-393" />
    </main>;
}